import React from "react";
import PropTypes from "prop-types";
// import MediaQuery from 'react-responsive';
import withStyles from "@material-ui/core/styles/withStyles";
import headerStyle from "assets/jss/material-kit-pro-react/components/headerStyle.jsx";

const style = theme => ({
    ...headerStyle,
    candidHeader: {
        position: 'fixed',
        top: 0,
        width: '100%',
        'z-index': 1120
    }
})

class FCHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = { collapsed: 'collapsed' };
        this.toggleSidenav = this.toggleSidenav.bind(this)
        this.closeSidenav = this.closeSidenav.bind(this)
    }

    toggleSidenav(e) {
        let className = (this.state.collapsed === "collapsed") ? "" : "collapsed";
        this.setState({ collapsed: className });
    }

    closeSidenav(e) {
        this.setState({ collapsed: 'collapsed' });
    }

    render() {
        const { classes } = this.props;
        return (
            <div id="multisite_nav_wrapper">

                <link rel="stylesheet" type="text/css" href="https://cdn.foundationcenter.org/fc_wrapper/extension/fcorg/design/fcorg_user/stylesheets/multisite-nav-candid.css" />
                {/* MULTISITE_NAV START */}
                <div 
                    id="nav-multisite" 
                    className={`ms-navigation nav-visible initialized ${this.state.collapsed} ${classes.candidHeader}`}
                    // onClick={this.toggleSidenav}
                    style={{display: 'none', opacity: 0, pointerEvents: 'none'}}>
                    <div className="trigger-bg">
                        <div className="trigger-container">
                            <span id="login-connect-placeholder"></span>
                            <div className="trigger-wrapper">
                                <span id="ms-trigger">Candid at a Glance <span className="ms-icon ms-icon-" onClick={this.toggleSidenav}></span></span>
                            </div>
                        </div>
                    </div>

                    <div className="content-bg">
                        <div className="ms-content">
                            <section className="ms-navwrapper">
                                <div className="ms-org">
                                    <h1>
                                        <a href="https://candid.org/" target="_blank" rel="noopener noreferrer">
                                            <span className="candid-logo">
                                                <span className="screen-reader-text">Candid.</span>
                                                <span className="logo-text">.</span>
                                            </span>
                                        </a>
                                    </h1>
                                    <h2>See the world. Make it better.</h2>

                                    <div className="contact">
                                        <a href="https://foundationcenter.force.com/custhelp/s/" target="_blank" rel="noopener noreferrer">Contact Us</a>
                                        <ul className="social">
                                            <li><a href="https://www.facebook.com/CandidDotOrg" target="_blank" rel="noopener noreferrer"><span className="ms-icon ms-icon-facebook"></span></a></li>
                                            <li><a href="https://www.twitter.com/CandidDotOrg" target="_blank" rel="noopener noreferrer"><span className="ms-icon ms-icon-twitter"></span></a></li>
                                            <li><a href="https://www.youtube.com/c/CandidDotOrg" target="_blank" rel="noopener noreferrer"><span className="ms-icon ms-icon-youtube"></span></a></li>
                                            <li><a href="https://www.linkedin.com/company/CandidDotOrg/" target="_blank" rel="noopener noreferrer"><span className="ms-icon ms-icon-linked-in"></span></a></li>
                                            <li><a href="https://www.instagram.com/CandidDotOrg/" target="_blank" rel="noopener noreferrer"><span className="ms-icon ms-icon-instagram"></span></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <section className="ms-links">
                                    <header>
                                        <meta httpEquiv="Content-Type" content="text/html;charset=UTF-8" />
                                        <h1>What do you need to move forward?</h1>
                                    </header>
                                    <div className="nav-wrapper">
                                        <nav className="ms-websites">
                                            <h2 className="toggle-menu">Our Websites <span className="ms-icon-angle-down"></span></h2>
                                            <div className="list-wrap">
                                                <ul className="ms-subnav">
                                                    <li><a href="https://candid.org" target="_blank" rel="noopener noreferrer">Candid</a></li>
                                                    <li><a href="https://foundationcenter.org" target="_blank" rel="noopener noreferrer">Foundation Center</a></li>
                                                    <li><a href="https://guidestar.org" target="_blank" rel="noopener noreferrer">GuideStar</a></li>
                                                </ul>
                                                <ul className="ms-subnav">
                                                    <li><a href="http://cfinsights.org" target="_blank" rel="noopener noreferrer">CF Insights</a></li>
                                                    <li><a href="https://glasspockets.org" target="_blank" rel="noopener noreferrer">Glasspockets</a></li>
                                                    <li><a href="https://grantcraft.org" target="_blank" rel="noopener noreferrer">GrantCraft</a></li>
                                                    <li><a href="https://grantspace.org" target="_blank" rel="noopener noreferrer">GrantSpace</a></li>
                                                    <li><a href="https://issuelab.org" target="_blank" rel="noopener noreferrer">IssueLab</a></li>
                                                    <li><a href="https://philanthropynewsdigest.org" target="_blank" rel="noopener noreferrer">Philanthropy News Digest</a></li>
                                                </ul>
                                            </div>
                                        </nav>
                                        <nav className="ms-products-services">
                                            <h2 className="toggle-menu">Our Products and Services <span className="ms-icon-angle-down"></span></h2>
                                            <div className="list-wrap">
                                                <ul className="ms-subnav">
                                                    <li><a href="https://fconline.foundationcenter.org" target="_blank" rel="noopener noreferrer">Foundation Directory Online</a></li>
                                                    <li><a href="https://maps.foundationcenter.org" target="_blank" rel="noopener noreferrer">Foundation Maps</a></li>
                                                    <li><a href="https://foundationcenter.org/gain-knowledge/foundation-data/foundation-center-apis" target="_blank" rel="noopener noreferrer">Foundation Center APIs</a></li>
                                                    <li><a href="https://foundationcenter.org/connect-with-us/funding-information-network" target="_blank" rel="noopener noreferrer">Funding Information Network</a></li>
                                                    <li><a href="https://gtionline.foundationcenter.org" target="_blank" rel="noopener noreferrer">Grants to Individuals Online</a></li>
                                                    <li><a href="https://www.guidestar.org/search" target="_blank" rel="noopener noreferrer">Guidestar Nonprofit Profiles</a></li>
                                                    <li><a href="https://learn.guidestar.org/products/guidestar-pro" target="_blank" rel="noopener noreferrer">Guidestar Pro</a></li>
                                                    <li><a href="https://learn.guidestar.org/products/verification-solutions/guidestar-charity-check" target="_blank" rel="noopener noreferrer">Guidestar Charity Check</a></li>
                                                    <li><a href="https://learn.guidestar.org/products/business-solutions/guidestar-apis" target="_blank" rel="noopener noreferrer">Guidestar APIs</a></li>
                                                    <li><a href="https://foundationcenter.org/gain-knowledge" target="_blank" rel="noopener noreferrer">Knowledge Services</a></li>
                                                    <li><a href="https://learn.guidestar.org/products/nonprofit-compensation-solutions/guidestar-nonprofit-compensation-report" target="_blank" rel="noopener noreferrer">Nonprofit Compensation Report</a></li>
                                                    <li><a href="https://grantspace.org/training/" target="_blank" rel="noopener noreferrer">Nonprofit Training</a></li>
                                                </ul>
                                            </div>
                                        </nav>
                                    </div>
                                </section>
                            </section>
                        </div>
                        <div className="find-us-bg">
                            <section className="ms-find-location ms-content">
                                <h1>Candid gets you the information you need to do good.</h1>
                                <div className="find-us">
                                    <h2>Find us in your community</h2>
                                    <form id="ms-find-us-Form" method="get" onSubmit={this.action} target="_blank" rel="noopener noreferrer" _lpchecked="1" action="https://foundationcenter.org/find-us">
                                        <input type="text" name="zip" className="input-zipcode" id="zipcode" placeholder="Enter ZIP code, city, state, or country" />
                                        <input type="submit" name="go" className="ms-find-us-button" alt="Find Location" value="Find Location" />
                                    </form>
                                </div>
                            </section>
                        </div>
                        {/* ms-content */}
                    </div>
                </div>
                {/* MULTISITE_NAV END */}
                
                {/* UNIVERSAL FOOTER START */}
                <div id="universal-footer" style={{display: 'none', opacity: 0, pointerEvents: 'none'}}>
                    <div id="uf-org">
                        <div className="uf-wrapper">
                            <div id="logo-wrap">
                                <h1>
                                    <a href="https://candid.org/" target="_blank" rel="noopener noreferrer">
                                        <span className="candid-logo">
                                            <span className="screen-reader-text">Candid.</span>
                                            <span className="logo-text">.</span>
                                        </span>
                                    </a>
                                </h1>
                            </div>
                            <h2>Candid gets you the information you need to do good. </h2>
                        </div>
                    </div>
                    <div id="uf-info">
                        <div className="uf-wrapper">
                            <div id="logo-space"></div>
                            <div id="text">
                                <small>Copyright &copy; {1900 + new Date().getYear()} Candid. All rights reserved.  Candid is a 501c3 nonprofit organization, <a href="https://www.guidestar.org/profile/13-1837418" target="_blank" rel="noopener noreferrer">EIN 13-1837418</a>.  Donations are tax-deductible.</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
                    
    }
}

FCHeader.propTypes = {
    classes: PropTypes.object
}
                    
export default withStyles(style)(FCHeader);


// WEBPACK FOOTER //
// ./src/components/Header/FCHeader.jsx